import React, { useState, useRef, useCallback } from "react";
import {
  StyleSheet,
  View,
  TextInput,
  TextInputProps,
  TouchableOpacity,
  TouchableWithoutFeedback,
  Image,
  Text,
} from "react-native";
import { colors } from "src/assets";

export type InputProps = TextInputProps & {
  onSend: () => void;
};

export const Input: React.FC<InputProps> = ({ onSend, ...props }) => {
  const textInputRef = useRef<TextInput>(null);
  return (
    <TouchableWithoutFeedback onPress={() => textInputRef.current?.focus()}>
      <View style={styles.root}>
        <svg
          style={styles.icon}
          width="20"
          height="19.673"
          viewBox="0 0 20 19.673"
        >
          <path
            d="M1.913,19.5a.7.7,0,0,1-.153-.84l1.13-2.173A3.9,3.9,0,0,1,0,12.724V8.335A3.893,3.893,0,0,1,3.889,4.447H4V3.888A3.893,3.893,0,0,1,7.892,0h8.22A3.892,3.892,0,0,1,20,3.888V8.277a3.893,3.893,0,0,1-3.888,3.889H16v.558a3.893,3.893,0,0,1-3.889,3.888H7.153L2.764,19.555a.7.7,0,0,1-.852-.059ZM1.392,8.335v4.389a2.5,2.5,0,0,0,2.5,2.5h.08a.7.7,0,0,1,.617,1.017l-.335.645,2.3-1.544a.7.7,0,0,1,.387-.118h5.167a2.5,2.5,0,0,0,2.5-2.5V8.335a2.5,2.5,0,0,0-2.5-2.5H3.889A2.5,2.5,0,0,0,1.392,8.335Zm4-4.447v.559h6.712A3.893,3.893,0,0,1,16,8.335v2.439h.115a2.5,2.5,0,0,0,2.5-2.5V3.888a2.5,2.5,0,0,0-2.5-2.5H7.892A2.5,2.5,0,0,0,5.4,3.888ZM4.123,12.774a.653.653,0,1,1,0-1.305h7.846a.653.653,0,1,1,0,1.305Zm0-2.811a.653.653,0,1,1,0-1.305h7.846a.653.653,0,1,1,0,1.305Z"
            fill="#7a7a7a"
          />
        </svg>
        {/* <span role="textbox" placeholder="jonny" contentEditable>
          wer
        </span> */}
        <TextInput
          ref={textInputRef}
          style={styles.input}
          placeholderTextColor={colors.chokyGray10}
          multiline={true}
          numberOfLines={3}
          {...props}
        />
        <TouchableOpacity
          style={[
            styles.btn,
            !props.value || props.value.length === 0 ? styles.btnInactive : {},
          ]}
          onPress={onSend}
          disabled={!props.value || props.value.length === 0}
        >
          <Image
            source={require("./assets/send.png")}
            style={{ width: 30, height: 30 }}
          />
        </TouchableOpacity>
      </View>
    </TouchableWithoutFeedback>
  );
};

const styles = StyleSheet.create({
  root: {
    flexDirection: "row",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    backgroundColor: colors.chokuGray11,
    padding: 16,
  },
  icon: {
    marginTop: 8,
    marginRight: 8,
  },
  input: {
    flex: 1,
    outlineStyle: "none",
    marginTop: 8,
  },
  btn: {},
  btnInactive: {
    opacity: 0.5,
  },
});
